import axios from '@/utils/request';

export const rackTree = ( containerNo ) => axios.get("/blade-wems/rack/tree?containerNo=" + containerNo);

export const getClusterInfo = (deviceId) => axios.get('/blade-wems/cluster/info?deviceId=' + deviceId);

export const getRackInfo = (deviceId) => axios.get('/blade-wems/rack/info?deviceId=' + deviceId);

export const clusterList =  ( containerNo ) => axios.get("/blade-wems/container/cluster/list?containerNo=" + containerNo);

export const clusterAndRack =  ( deviceNo ) => axios.get("blade-wems/container/clusterAndRack/data/list?deviceNo=" + deviceNo);

export const getDuiList =(containerNo) => axios.get("/blade-wems/container/cluster/data/list?containerNo=" + containerNo);

export const getRackReal = (rackId) => axios.get('/blade-wems/rack/data/real?rackId=' + rackId);

export const rackBatteryList = (rackId) => axios.get('/blade-wems/rack/battery/list?rackId=' + rackId);

export const packTemperatureList = (rackId) => axios.get('/blade-wems/rack/pack/temperature/list?rackId=' + rackId);

export const raclPackList = (rackId) => axios.get("/blade-wems/rack/pack/list?rackId=" + rackId);

export const batteryInfoList = (rackId) => axios.get("/blade-wems/rack/battery/info/list?rackId=" + rackId);

export const getRackBalance = (clusterId) => axios.get('/blade-wems/cluster/rackBalance?clusterId=' + clusterId);

export const getClusterReal = ( clusterId ) => axios.get('/blade-wems/cluster/data/real?clusterId=' + clusterId);

export const getRackPageList = (params) => axios.get("/blade-wems/device/rackPage", { params });

export const getDuiPageList = (containerNo) => axios.get("/blade-wems/device/getDui?containerNo=" + containerNo);

export const getDuiPage = (params) => axios.get("/blade-wems/device/duiPage", { params });

export const getTagData = (params) => axios.get("/blade-wems/contagday/getTagData", { params });

export const getBatteryHisDay = (params) => axios.get("/blade-wems/battery/his/day", { params });

export const getBatteryHisMonth = (params) => axios.get("/blade-wems/battery/his/month", { params });

export const getBatteryHisYear = (params) => axios.get("/blade-wems/battery/his/year", { params });

export const doClusterConnect = (params) => axios.post("/blade-wems/cluster/connect/set", params);

export const doRackRunSet  = (params) => axios.post("/blade-wems/rack/run/set", params);

export const doManaulRunSet  = (params) => axios.post("/blade-wems/rack/alarm/clear", params);

export const doClusterRunSet  = (params) => axios.post("/blade-wems/cluster/connect/set", params);



export const getContainerEev = (params) => axios.get("/blade-wems/container/env/data", {params});



export const getBatteryDay = (params) => axios.get('/blade-wems/battery/his/status/day', {params});

export const getBatteryMonth = (params) => axios.get('/blade-wems/battery/his/status/month', {params});

export const getBatteryYear = (params) => axios.get('/blade-wems/battery/his/status/year', {params});

export const getAirCon = (params) => axios.get("/blade-wems/container/get/airCond/state", {params});

export const setArconOnf = (params) => axios.post("/blade-wems/container/set/airCond/onOff", params);

export const setArconstate = (params) => axios.post("/blade-wems/container/set/airCond/state", params);

export const startplay = (deviceNo, startTime, endTime) => axios.post("/blade-wems/container/control/startplay?deviceNo=" + deviceNo + "&startTime=" + startTime + "&endTime=" + endTime );

export const getPlayUrl = (deviceNo) => axios.get("/blade-wems/container/stream/hls/url?deviceNo=" + deviceNo);


export const stopplay = (deviceNo, startTime, endTime) => axios.post("/blade-wems/container/control/stopplay?deviceNo=" + deviceNo + "&startTime=" + startTime + "&endTime=" + endTime );

export const playback = (deviceNo, seek) => axios.get("/blade-wems/container/playSeek?deviceNo=" + deviceNo + "&seek=" + seek);


export const setAircond= (params) => axios.post("/blade-wems/container/set/airCond/param", params);



export const resetBMS = (clusterId) => axios.post("/blade-wems/rack/bms/reset?clusterId=" + clusterId);

export const getIODeviceList = () => axios.get("/blade-wems/env/system/config/io/device/list");

export const getIODevicetagList = () => axios.get("/blade-wems/env/system/config/io/device/tag/list");

export const getCardList = (containerNo) => axios.get("/blade-wems/env/system/config/list?containerNo=" + containerNo);

export const IoTagList = (params) => axios.get("/blade-wems/env/system/config/io/tag/list", { params });

export const saveTagList = (params) => axios.post("/blade-wems/env/system/config/io/tag/create", params);

export const getPCSList = () => axios.get('/blade-wems/env/system/config/pcs/device/list');

export const addEnvCard = (params) => axios.post("/blade-wems/env/system/config/create", params);

export const getEnvCardList = (id) => axios.get("/blade-wems/env/system/config/list?id=" + id);

export const removeEnvCard = (id) => axios.post("/blade-wems/env/system/config/remove?id=" + id);

export const getEnvCardListAll = (containerNo) => axios.get("/blade-wems/env/system/config/data/list?containerNo=" + containerNo);

export const sendCommand1 = () => axios.post("/blade-wems/ems/linkage/set");
export const sendCommand2 = () => axios.post("/blade-wems/ems/structure/set");

export const dehumidifierOnOff = (params) => axios.post("/blade-wems/container/set/temp/onOff", params);


export const getSLINGdata = (deviceNo) => axios.get("/blade-wems/container/get/airCond/status?deviceNo=" + deviceNo);

export const sendcoldTemp = (params) => axios.post("/blade-wems/container/set/airCond/coldTemp", params);

export const sendhotTemp = (params) => axios.post("/blade-wems/container/set/airCond/hotTemp", params);

export const sendSLINGONOff = (params) => axios.post("/blade-wems/container/set/airControl/onOff", params);

export const setylparam = (params) => axios.post("/blade-wems/container/set/yl/param", params );
export const setylmode = (params) => axios.post("/blade-wems/container/set/yl/mode", null,{ params });
export const setyltempSelect = (params) => axios.post("/blade-wems/container/set/yl/tempSelect", null, { params });

export const getOtherEnv = (containerNo) => axios.get("/blade-wems/container/mainAndChild/list?containerNo=" + containerNo);

//排风扇状态打开关闭接口
export const setDoFanAC = (params) => axios.post("/blade-wems/gaoyue344/do/ac", params);


export const setDoFan = (params) => axios.post("/blade-wems/gaoyue344/do/fan", params);

export const setDoEpo2 = (params) => axios.post("/blade-wems/gaoyue344/do/epo2", params);

export const setDoFire= (params) => axios.post("/blade-wems/gaoyue344/do/fire", params);

export const setDoWarnOut= (params) => axios.post("/blade-wems/gaoyue344/do/warnOut", params);

export const setDoGuard= (params) => axios.post("/blade-wems/gaoyue344/do/guard", params);

export const shuangdengcontrol= (params) => axios.post("/blade-wems/shuangdeng/do/control", params);


export const getDoorPic = (params) => axios.get("/blade-wems/images/door/page", { params });

